<template>
    <!--注文完了パーツ-->
    <div id="sh070" class="sh070" v-cloak>
        <div class="itemTitle">
            <h2>{{$t("common.labels.orderProcedure")}}</h2>
        </div>
        <div class="section-inner">
            <!-- ご注文完了 -->
            <div class="sectionTitle">
                <h3>{{$t("sh070.labels.orderComplete")}}</h3>
            </div>
            <ul class="flowchart">
                <!-- カートの確認 -->
                <li v-if="tdkSkipFlg || sh070Init.dairiInputKbn == '1'"><span>{{$t("common.labels.step1")}}</span>{{$t("sh060.labels.cartOfOrderContents")}}</li>
                <!-- ご注文内容確認 -->
                <li v-if="confirmFlg"><span>{{$t("common.labels.step2")}}</span>{{$t("common.labels.confirmationOfOrderContents")}}</li>
                <!-- ご注文登録完了 -->
                <li v-if="completeFlg" class="flow-current"><span>{{$t("common.labels.step3")}}</span>{{$t("common.labels.orderRegistrationComplete")}}</li>
            </ul>
            <div class="finishOrderMessage" v-if="message!=''&&message!=undefined" v-html="message"></div>
            <div class="finishOrderMessage" v-else-if="sh070Init.errMessage!=''&&sh070Init.errMessage!=undefined" v-html="sh070Init.errMessage"></div>
            <div class="finishOrderMessage" v-else >
                <h4>
                    <!-- ご注文を承りました。 -->
                    {{$t("sh070.labels.receivedOrder")}}
                </h4>
                <span>
                    &nbsp;
                </span>
                <p>
                    <!-- ただいま、ご注文の確認メールをお送りさせていただきました。 -->
                    {{$t("sh070.labels.weSendingEmail")}}
                </p>
                <p>
                    <!-- 万一、ご確認メールが届かない場合は、トラブルの可能性もありますので -->
                    {{$t("sh070.labels.errorSendMail")}}
                </p>
                <p>
                    <!-- 大変お手数ではございますがもう一度お問い合わせいただくか、お電話にて -->
                    {{$t("sh070.labels.contactViaPhone")}}
                </p>
                <p>
                    <!-- お問い合わせくださいませ。 -->
                    {{$t("sh070.labels.contactUs")}}
                </p>
            </div>

            <template v-for="(product, index) in sh070Init.orderDtlInfo">
                <div :class="`digitalItemInfo ${product.S_ITEM_CD}`" v-if="product.ITEM_KBN == 6" :key="index">
                    <span class="itemCd">{{product.S_ITEM_CD}}</span>
                    <span class="itemNm">{{product.ITEM_NM}}</span>
                    <div class="digitalIdInfo" v-if="product.DIGITAL_ITEM_TYPE == 1 && product.ITEM_KBN == 6">
                        <div class="digitalId" v-if="product.DIGITAL_ID">
                            {{product.DIGITAL_ID}}
                        </div>
                        <div class="digitalIdNot" v-else>
                            {{$t('sh070.labels.idInPreparation')}}
                        </div>
                        <span class="fixedUrl" v-if="product.FIXED_URL != null">
                            <a :href="product.FIXED_URL" target="_blank">{{product.FIXED_URL}}</a>
                        </span>
                    </div>
                    <div class="barInfo" v-if="product.DIGITAL_ITEM_TYPE == 2 && product.ITEM_KBN == 6">
                        <span  class="barUrl" v-if="product.BAR_URL">
                            <a href="#" @click.prevent="openBarcode(product.BAR_URL)">{{ $t('common.labels.barcodeDisp') }}</a>
                        </span>
                        <span  class="BarUrlNot" v-else>
                            {{$t('sh070.labels.barInPreparation')}}
                        </span>
                    </div>
                </div>
            </template>

            <div>
                <button @click="doRedirect(9)" v-if="sh070Init.errMessage!=''&&sh070Init.errMessage!=undefined&&sh070Init.orderHisFlg==1" class="btnSubmit mr-3" type="button">
                    <!-- 購入履歴画面へ -->
                    {{$t("sh070.buttons.purchaseHistory")}}
                </button>
                <button @click="doRedirect(1)" class="btnSubmit" type="button">
                    <!-- トップページへ戻る -->
                    {{$t("common.buttons.backToTopPage")}}
                </button>
            </div>
            <!--受注ヘッダー情報-->
            <div v-for="(item,index) in sh070Init.orderInfo" :key="index">
                <span style="display: none" id="transaction_id">{{item.ORDER_CD}}</span>
                <span style="display: none" id="itemSumEx">{{item.ITEMSUM_TAX_EX}}</span>
                <span style="display: none" id="itemSumIn">{{item.ITEMSUM_TAX_IN}}</span>
                <span style="display: none" id="itemSumTax">{{item.ITEMSUM_TAX}}</span>
                <span style="display: none" id="siireTnkSum">{{item.SIIRE_TNK_SUM}}</span>
                <span style="display: none" id="valueIn">{{item.SEIKYU_TAX_IN}}</span>
                <span v-if="item.SEIKYU_TAX_EX > 0" style="display: none" id="valueEx">{{item.SEIKYU_TAX_EX}}</span>
                <span v-else style="display: none" id="valueEx">0</span>
                <span style="display: none" id="tax">{{item.SEIKYU_TAX}}</span>
                <span style="display: none" id="shippingIn">{{item.SORYO_TAX_IN}}</span>
                <span style="display: none" id="shippingEx">{{item.SORYO_TAX_EX}}</span>
            </div>
            <!--受注明細情報-->
            <div v-for="(item,index) in sh070Init.orderDtlInfo" :key="index">
                <span style="display: none" :id="'meiLineNo'+index">{{item.ORDER_LINE_NO}}</span>
                <span style="display: none" :id="'itemId'+index">{{item.S_ITEM_CD}}</span>
                <span style="display: none" :id="'itemName'+index">{{item.ITEM_NM}}</span>
                <span style="display: none" :id="'itemCategory'+index">{{item.CATEGORY_CD1}}</span>
                <span style="display: none" :id="'itemQuantity'+index">{{item.QTY}}</span>
                <span style="display: none" :id="'itemPriceIn'+index">{{item.TNK_TAX_IN}}</span>
                <span style="display: none" :id="'itemPriceEx'+index">{{item.TNK_TAX_EX}}</span>
                <span style="display: none" :id="'itemSiireTnk'+index">{{item.SIIRE_TNK}}</span>
                <span style="display: none" :id="'meiItemSumIn'+index">{{item.MEI_ITEMSUM_TAX_IN}}</span>
                <span style="display: none" :id="'meiSireTnkSum'+index">{{item.MEI_SIIRE_TNK_SUM}}</span>
            </div>

            <!-- カスタマーリングス連携オプション -->
            <div v-if="cusRingsFlg">
                <input type="hidden" id="cr_user1" :value="cusRings.orderNo"/>  <!-- 注文番号 -->
                <input type="hidden" id="cr_user2" :value="cusRings.itemSum"/>  <!-- 商品合計金額 -->
                <input type="hidden" id="cr_user3" :value="cusRings.itemCd"/>   <!-- 商品コード -->
                <input type="hidden" id="cr_user4" :value="cusRings.itemQty"/>  <!-- 数量 -->
                <input type="hidden" id="cr_user5" :value="cusRings.itemTnk"/>  <!-- 商品単価 -->
            </div>
        </div>
        <!-- ※バーコード情報※ -->
        <b-modal v-model="isModalBarcode"
            size="md"
            centered
            :title="$t('common.labels.barcode')"
            :footer-class="'mx-auto'">
            <div class="mx-auto">
                <img class="barcodeImg" :src="barCodeImg" :alt="$t('common.labels.barcode')">
            </div>
            <div slot="modal-footer">
                <!-- 閉じる -->
                <input @click="isModalBarcode = false" :value="$t('pt430.buttons.close')" type="button">
            </div>
        </b-modal>
    </div>
</template>

<script>
/* 
* Import libs and componnents
*/
import SiteConstants from 'assets/const/SiteConstants.json';
import common from 'assets/js/common';
import axios from "assets/js/request";
import { mapMutations } from 'vuex';

export default {
    /* 
    * Name of component
    */
    name: "SH070ShopperComplete",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {

    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            SiteConstants: SiteConstants,
            message:"",
            site: "",
            sh070Init: {
                orderInfo:[],
                orderDtlInfo:[]
            },
            sh070ReqModel:{},
            tdkSkipFlg : false,
            paySkipFlg : false,
            cusRingsFlg: false,
            confirmFlg : false,
            completeFlg : false,
            cusRings: {
                orderNo: "",
                itemSum: 0,
                itemCd: "",
                itemQty: "",
                itemTnk: ""
            },
            isModalBarcode: false,
            barCodeImg: '',
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH070 + _this.$UrlConstants.DO_INIT, _this.sh070ReqModel).then(function(response) {
            _this.sh070Init = response.data;
            if (_this.sh070Init.tdkSkipFlg == '0') {
                _this.tdkSkipFlg = true;
            }
            if (_this.sh070Init.paySkipFlg == '0') {
                _this.paySkipFlg = true;
            }
            if (_this.sh070Init.cusRingsFlg == '1') {
                _this.cusRingsFlg = true;
            }
            _this.confirmFlg = true;
            _this.completeFlg = true;

            // カスタマーリングス連携オプション
            if (_this.cusRingsFlg) {
                _this.cusRings.orderNo = _this.sh070Init.orderInfo[0].ORDER_CD;
                for (var i=0; i<_this.sh070Init.orderInfo.length; i++){
                    _this.cusRings.itemSum = _this.cusRings.itemSum + _this.sh070Init.orderInfo[i].ITEMSUM_TAX_IN;
                }
                const itemCdList = _this.sh070Init.orderDtlInfo.map(function(item) {
                    return item.S_ITEM_CD;
                });
                const itemQtyList = _this.sh070Init.orderDtlInfo.map(function(item) {
                    return item.QTY;
                });
                const itemTnkList = _this.sh070Init.orderDtlInfo.map(function(item) {
                    return item.TNK_TAX_IN;
                });
                _this.cusRings.itemCd = itemCdList.join(",");
                _this.cusRings.itemQty = itemQtyList.join(",");
                _this.cusRings.itemTnk = itemTnkList.join(",");

                _this.cusRingsConversion();
            }
        }).catch(function(error) {
            common.errorAPI(error);
        });
    },
    /* 
    * Methods
    */
    methods: {
        ...mapMutations('sh070', {
            commitSetSh070Init: 'SET_SH070_INIT',
            commitSetSh070Request: 'SET_SH070_REQUEST'
        }),
        syncSh070InitState(payload) {
            this.commitSetSh070Init(Object.assign({}, payload));
        },
        syncSh070RequestState(payload) {
            this.commitSetSh070Request(Object.assign({}, payload));
        },
        doRedirect:function(pageNo){
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:pageNo}});
        },

        // カスタマーリングス連携
        cusRingsConversion: function() {
            var _this = this;
            // 要素が画面上に表示されているか確認
            if (document.getElementById("cr_user1") != null && document.getElementById("cr_user2") != null
                && document.getElementById("cr_user3") != null && document.getElementById("cr_user4") != null
                && document.getElementById("cr_user5") != null
            ) {
                // コンバージョン達成
                PAC_CR_CV.postLog();
            } else {
                // 0.5秒後に再度実行
                window.setTimeout(function(){
                    _this.cusRingsConversion();
                }, 500);
            }

        },

        // バーコード表示
        openBarcode: function(imageUrl){
            this.isModalBarcode=true;
            const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
            this.barCodeImg = baseUrl + imageUrl;
        },
    },
    created: function(){
        var _this = this;
        const sh070StoreState = _this.$store && _this.$store.state && _this.$store.state.sh070
            ? _this.$store.state.sh070
            : null;

        if (sh070StoreState) {
            if (sh070StoreState.sh070Init && Object.keys(sh070StoreState.sh070Init).length > 0) {
                _this.sh070Init = Object.assign({}, _this.sh070Init, sh070StoreState.sh070Init);
            }
            if (sh070StoreState.sh070Request && Object.keys(sh070StoreState.sh070Request).length > 0) {
                _this.sh070ReqModel = Object.assign({}, _this.sh070ReqModel, sh070StoreState.sh070Request);
            }
        }
        //Get param from router when contructor this.
        var data = _this.$route.params;
        _this.sh070ReqModel.orderCd = data.orderCd;
        _this.message = data.message;
    },
    watch: {
        sh070Init: {
            handler: function(value) {
                this.syncSh070InitState(value);
            },
            deep: true,
            immediate: true
        },
        sh070ReqModel: {
            handler: function(value) {
                this.syncSh070RequestState(value);
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
<style scoped>
a {
  color: blue;
  text-decoration: none;
}
.barcodeImg {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style>